export default "__VITE_ASSET__BQ$KjKoI__"